/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Model.css';
import dbCode from './dbCode.jpg'

class Model extends React.Component {
  constructor(props){
    super(props)
    this.state={
      
    }
    this.call=this.call.bind(this)
  }


  call=()=>{
    const url=`/digitalAssets/center/callMe`
    
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
   };
   fetch(url,myInit)
      .then(response => response.json())
      .then(data => {
      })
      .catch(e => console.log("Oops, error", e))
      this.props.close()
  }

  render() {
    // console.log(this.props.isShow)
    return (
      <div className={this.props.isShow?s.root:s.hide}>

        <div className={s.model}>
          <div className={s.tipBox}>
            <div className={s.tipTxt}>感谢您的支持！</div>
            <div className={s.tipTxt}>请保持手机畅通，稍后数据顾问将主动联系您。</div>
            <div className={s.codeImg}><img  src={dbCode}/></div>
            <span className={s.redTxt}>扫描二维码添加数据顾问个人微信！</span>
            <div className={s.tipOK} onClick={this.call}>确认</div>
          </div>

        </div>

      </div>
    )

  }
}

export default withStyles(s)(Model);



// WEBPACK FOOTER //
// src/components/Model/Model.js